const invertedMessages = {
  'Manage Classification Rules': 'external.dahsboard.manageClassification',
  Identities: 'external.dahsboard.identities',
};

export default invertedMessages;
